// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1_-Xm","rootSmall":"AddTileButton_rootSmall__1YcO6"};